import i18n from '@/vendors/i18n'

export default {
  name: 'transaction_tax_receipt',
  model: 'actions_data.transaction.tax_receipt_requested',
  type: 'input_checkbox',
  settings: {
    icon: 'tax_certificate',
    category: 'legal_fields',
    require_model: true
  },
  content: {
    title: i18n.getLocalesTranslations('$procedure_block.name_id_fiscal_attest')
  },
  components: [
    {
      path: 'molecules/ModuleInputText',
      model: 'attributes.label',
      value: i18n.getLocalesTranslations('$block_fiscal_attest.label_fiscal_attest'),
      content: {
        label: i18n.getLocalesTranslations('literal.question')
      }
    },
    {
      path: 'molecules/ModuleInputTextarea',
      model: 'attributes.text',
      value: i18n.getLocalesTranslations('$block_fiscal_attest.text_fiscal_attest'),
      settings: {
        variables: ['tax_percentage_result'],
        type: 'textarea'
      },
      content: {
        label: i18n.getLocalesTranslations('literal.text')
      }
    },
    {
      path: 'molecules/ModuleInputSelect',
      model: 'attributes.default_value',
      value: false,
      options: [
        {
          label: i18n.getLocalesTranslations('literal.checked'),
          value: true
        },
        {
          label: i18n.getLocalesTranslations('literal.not_checked'),
          value: false
        }
      ],
      content: {
        label: i18n.getLocalesTranslations('literal.default_value')
      }
    }
  ],
  is_allowed: {
    'procedure.category': ['donation']
  }
}
